export default "__VITE_ASSET__DnfA8jOH__"